import React from "react";
import { Table } from "antd";

const PatientsTable = ({ patients, columns, onRow }) => {
  return (
    <Table 
      dataSource={patients} 
      columns={columns} 
      rowKey="key"
      onRow={onRow}
    />
  );
};

export default PatientsTable; 